import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UtilitiesService } from '@services/utilities.service';
import { ITabList } from '@shared/interface/tablist.interface';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { DistributorStatusEnum } from '@config/enum/distributor.enum';
import { TabListLabelDetailDistributor } from '../../enum/tablist-label.enum';
import { DistributorService } from '../../distributor.service';
import { BehaviorSubject } from 'rxjs';
import { IHeaderDistributorDetail } from '../../interfaces/detail-header.interface';

@Component({
  selector: 'app-detail-reject',
  templateUrl: './detail-reject.component.html',
  styleUrls: ['./detail-reject.component.scss'],
})
export class DetailRejectComponent implements OnInit, AfterViewInit {
  @Input() detailHeaderSubject!: BehaviorSubject<IHeaderDistributorDetail>;
  @Input() distributorStatusEnum: string | DistributorStatusEnum;

  tabIndex = 0;
  tabList: ITabList[];

  get headerValue() {
    if (this.detailHeaderSubject && this.detailHeaderSubject.value) return this.detailHeaderSubject.value;
    return this.distributorService.DistributorDetailHeader;
  }

  constructor(private rolePrivilegeService: RolePrivilegeService, private distributorService: DistributorService, public utils: UtilitiesService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.getTabList();
  }

  getTabList() {
    this.distributorService.distributorDetailHeaderSubject.subscribe((value) => {
      if (!value || Object.keys(value).length <= 0) return;
      this.tabList = this.distributorService.generateDistributorDetailTabList(this.headerValue.status_enum);
      this.tabList.map((tab, index) => {
        tab.privilege = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'DETAIL_DISTRIBUTOR', tab.enum);
        tab.index = index;
        tab.component = this.distributorService.setTabListComponent(tab.enum);
      });
    });
  }

  handleTabChange = (e: number) => (this.tabIndex = e);

  protected readonly TabListLabelDetailDistributor = TabListLabelDetailDistributor;
}
